import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';

export default function DebitWarningDeactivation({ data }) {
    const { establishmentId, createdAt, userName } = data;
  
    const { establishments } = useSelector(state => state.login);
    const { establishmentName } = establishments?.find(establishment => +establishment?.establishmentId == +establishmentId) || {};

  return(
    <Grid container>
      <Grid xs={12}>
        <Typography color='primary'>
          O lembrete de débito para o estabelecimento <b>{establishmentName}</b> foi desativado em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b> por <b>{userName}.</b>
        </Typography>
      </Grid>
    </Grid>
  );
}